/* eslint-disable no-console */
/* ------------------------------------------------------------------ */
/* 1. **Базовая декларация**: один объект, на каждый цвет — по 2 тона  */
/* ------------------------------------------------------------------ */
const PALETTE = {
    /* neutrals */
    white: { light: "#FFFFFF", dark: "#111315" },
    black: { light: "#000000", dark: "#FFFFFF" },
    alwaysWhite: { light: "#FFFFFF", dark: "#FFFFFF" },
    alwaysBlack: { light: "#000000", dark: "#000000" },
    whiteOpacity: { light: "#ffffffe5", dark: "#00000066" },

    /* surfaces / containers */
    lightGray: { light: "#F8F9FA", dark: "#1A1C1F" },
    modalGrayBg: { light: "#F8F9FA", dark: "#181A1D" },
    borderGray: { light: "#E5E5E5", dark: "#333333" },
    darkGray: { light: "#000000", dark: "#FFFFFF" },

    /* text */
    titleBlack: { light: "#000000", dark: "#FFFFFF" },
    textGray: { light: "#666666", dark: "#999999" },
    textSecondary: { light: "#666666", dark: "#999999" },
    textDarkGray: { light: "#333333", dark: "#CCCCCC" },

    /* accent */
    primary: { light: "#4C78DF", dark: "#4C78DF" },
    primaryLight: { light: "#7BA0F2", dark: "#314D8C" },
    primaryDark: { light: "#2A4B8F", dark: "#1A2E5A" },

    /* misc */
    headerBackground: { light: "#ffffff", dark: "#1a1a1a" },
    headerBorder: { light: "#f0f0f0", dark: "#333333" },
    sidebarBackground: { light: "#ffffff", dark: "#1a1a1a" },
    sidebarBorder: { light: "#f0f0f0", dark: "#333333" },
};

/* список ключей для быстрого доступa */
export const COLOR_KEYS = Object.keys(PALETTE);

/* ------------------------------------------------------------------ */
/* 2.  Выставляем CSS-переменные, чтобы DOM перекрашивался мгновенно   */
/* ------------------------------------------------------------------ */
const root = document.documentElement;
const setVar = (k, v) => root.style.setProperty(`--${k}`, v);

export function setThemePalette(theme = "light") {
    COLOR_KEYS.forEach((k) => setVar(k, PALETTE[k][theme]));
    root.dataset.theme = theme; // <html data-theme="dark">
    if (theme === 'dark') {
        root.classList.add('dark');
    } else {
        root.classList.remove('dark');
    }
}

/* ------------------------------------------------------------------ */
/* 3.  Публичный объект COLORS → возвращает CSS-var                   */
/* ------------------------------------------------------------------ */
const FALLBACK = "#FF00FF";

export const COLORS = new Proxy(
    {},
    {
        get(_, prop) {
            if (PALETTE[prop]) return `var(--${String(prop)})`;
            if (process.env.NODE_ENV !== "production") {
                console.warn(
                    `[COLORS] Unknown key "${String(prop)}" – fallback (${FALLBACK})`
                );
            }
            return FALLBACK;
        },
    }
);
